import { Option } from '@/components/inputs/AutocompleteInput';
import { useGetUsersQuery } from '../../Users/services';
import { useState, useMemo } from 'react';

export const useUserOptions = () => {
  const [userSearch, setUserSearch] = useState('');
  const [selectedUser, setSelectedUser] = useState<Option | null>(null);

  const { data: usersData, isLoading: isUsersLoading } = useGetUsersQuery(
    {
      filters: { firstName: userSearch },
      paginated: { page: 1, pageSize: 20 },
    },
    { skip: userSearch.length < 3 }
  );

  const userOptions: Option[] = useMemo(() => {
    return (usersData?.items ?? []).map((user) => ({
      label: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email,
      data: user.id,
    }));
  }, [usersData]);

  const resetUser = () => {
    setUserSearch('');
    setSelectedUser(null);
  };

  return {
    userSearch,
    setUserSearch,
    selectedUser,
    setSelectedUser,
    userOptions,
    isUsersLoading,
    resetUser,
  };
};

export default useUserOptions;
